export default __webpack_public_path__ + "assets/Merida.af879fe8.png";